import { render, staticRenderFns } from "./FAvatarStack.vue?vue&type=template&id=26159302&"
import script from "./FAvatarStack.vue?vue&type=script&lang=js&"
export * from "./FAvatarStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports